import { LoginApi } from "../../service/API";
import { LocalData } from "../../service/localStorage";
const loginApi = new LoginApi();
const localData = new LocalData();

export const LoginAction = async ({token}) => {
  try {

    // {userId , accessToken, refreshToken , name , username}
    const data = await loginApi.loginWithMagic({token});
    localData.set('adminToken' , data.adminToken);
    localData.set('accessToken' , data.accessToken);
    localData.set('id' , data.userId);
    localData.set('refreshToken' , data.refreshToken);
    localData.set('username' , data.username);
    localData.set('name' , data.name);;

    return {
     ...data
    }

  } catch (error) {
    return null
    return Promise.reject(error);
   
  }
  
};




